import { getRoleSkillsByWeight } from "PFApp/activities/show/matches_v2/helpers/role_skills";
import { CustomValue, Weight } from "PFTypes";
import { useMemo } from "react";

import { useMatchCardContext } from "../match_card_context";

export const useSkillsOfWeight = (weight: Weight) => {
  const { custom_values: customValues, role } = useMatchCardContext();

  const roleSkills = useMemo(() => getRoleSkillsByWeight(role, weight), [role, weight]);

  const matchSkills = useMemo(
    () =>
      (customValues?.direct || []).filter(
        ({ id: matchedSkillId }) => roleSkills.findIndex(({ id }) => id === matchedSkillId) >= 0
      ) as CustomValue[],
    [customValues?.direct, roleSkills]
  );

  const missingMatchSkills = useMemo(
    () =>
      roleSkills.filter(({ id: roleSkillId }) => matchSkills.findIndex(({ id }) => id === roleSkillId) < 0),
    [matchSkills, roleSkills]
  );

  return {
    matchSkills,
    roleSkills,
    missingMatchSkills
  };
};
